import { AxiosError } from "axios";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { IQualidadeService } from "./qualidade_service";
import {
  GetAllQualidadeAcoesMelhoriasRequest,
  GetAllQualidadeAcoesMelhoriasResponse,
} from "../daos/read/get_all_qualidade_acoes_melhorias";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import {
  CreateAcoePreventivasRequest,
  CreateAcoePreventivasResponse,
} from "../daos/create/create_acoes_preventivas";
import {
  UpdadeAcoesPreventivasRequest,
  UpdateAcoesPreventivasResponse,
} from "../daos/update/update_acoes_preventivas";
import {
  CreateAcaoPreventivaCorretivaRequest,
  CreateAcaoPreventivaCorretivaResponse,
} from "../daos/create/create_acoes_preventiva_corretiva";
import {
  GetAllQualidadeAcaoPrevCorretivasRequest,
  GetAllQualidadeAcaoPrevCorretivasResponse,
} from "../daos/read/get_all_qualidade_acao_prev_corretivas";
import {
  UpdadeAcaoPrevCorretivasRequest,
  UpdateAcaoPrevCorretivasResponse,
} from "../daos/update/update_acao_preventivas_corretivas";
import {
  DeleteAcaoPrevCorretivasRequest,
  DeleteAcaoPrevCorretivasResponse,
} from "../daos/delete/delete_acao_preventivas_corretivas";
import {
  DeleteAcoesPreventivasRequest,
  DeleteAcoesPreventivasResponse,
} from "../daos/delete/delete_acoes_preventivas";
import {
  GetAllQualidadeCronogramaSGQRequest,
  GetAllQualidadeCronogramaSGQResponse,
} from "../daos/read/get_all_qualidade_cronogramasgq";
import {
  DeleteCronogramaSGQRequest,
  DeleteCronogramaSGQResponse,
} from "../daos/delete/delete_cronogramasgq";
import {
  CreateCronogramaSGQRequest,
  CreateCronogramaSGQResponse,
} from "../daos/create/create_CronogramaSGQ";
import {
  UpdateCronogramaSGQRequest,
  UpdateCronogramaSGQResponse,
} from "../daos/update/update_cronogramaSGQ";
import {
  GetAllQualidadeProvisaoRecursoRequest,
  GetAllQualidadeProvisaoRecursoResponse,
} from "../daos/read/get_all_qualidade_provisao_recurso";
import {
  DeleteProvisaoRecursoRequest,
  DeleteProvisaoRecursoResponse,
} from "../daos/delete/delete_provisao_recurso";
import {
  CreateProvisaoRecursoRequest,
  CreateProvisaoRecursoResponse,
} from "../daos/create/create_provisao_recurso";
import {
  UpdateProvisaoRecursoRequest,
  UpdateProvisaoRecursoResponse,
} from "../daos/update/update_provisao_recurso";
import {
  GetAllQualidadeIndicadoresRequest,
  GetAllQualidadeIndicadoresResponse,
} from "../daos/read/get_all_qualidade_indicadores";
import {
  DeleteIndicadoresRequest,
  DeleteIndicadoresResponse,
} from "../daos/delete/delete_indicadores";
import {
  CreateIndicadoresRequest,
  CreateIndicadoresResponse,
} from "../daos/create/create_indicadores";
import {
  UpdateIndicadoresRequest,
  UpdateIndicadoresResponse,
} from "../daos/update/update_indicadores";
import {
  GetAllQualidadeProcessosRiscosRequest,
  GetAllQualidadeProcessosRiscosResponse,
} from "../daos/read/get_all_qualidade_processos_riscos";
import {
  DeleteProcessoRiscosRequest,
  DeleteProcessoRiscosResponse,
} from "../daos/delete/delete_processo_riscos";
import {
  CreateProcessoRiscosRequest,
  CreateProcessoRiscosResponse,
} from "../daos/create/create_processo_riscos";
import { UpdateProcessoRiscosRequest } from "../daos/update/update_processo_riscos";
import {
  CopyProcessoRiscosRequest,
  CopyProcessoRiscosResponse,
} from "../daos/create/copy_processo_riscos";
import {
  GetAllQualidadeItemProcessoRiscosRequest,
  GetAllQualidadeItemProcessoRiscosResponse,
} from "../daos/read/get_all_qualidade_item_processo_riscos";
import {
  DeleteItemProcessoRiscosRequest,
  DeleteItemProcessoRiscosResponse,
} from "../daos/delete/delete_item_processo_riscos";
import {
  CreateItemProcessoRiscosRequest,
  CreateItemProcessoRiscosResponse,
} from "../daos/create/create_item_processo_riscos";
import {
  UpdateItemProcessoRiscosRequest,
  UpdateItemProcessoRiscosResponse,
} from "../daos/update/update_item_processo_riscos";
import {
  CreateItemProcessoRiscosInteresseRequest,
  CreateItemProcessoRiscosInteresseResponse,
} from "../daos/create/create_item_processo_riscos_interesse";
import {
  UpdateItemProcessoRiscosInteresseRequest,
  UpdateItemProcessoRiscosInteresseResponse,
} from "../daos/update/update_item_processo_riscos_interesse";
import {
  GetAllQualidadeItemProcessoInteresseRequest,
  GetAllQualidadeItemProcessoInteresseResponse,
} from "../daos/read/get_all_qualidade_item_processo_interesse";
import {
  DeleteItemProcessoInteresseRequest,
  DeleteItemProcessoInteresseResponse,
} from "../daos/delete/delete_item_processo_interesse";
import {
  GetAllQualidadeItemProcessoFatorRequest,
  GetAllQualidadeItemProcessoFatorResponse,
} from "../daos/read/get_all_qualidade_item_processo_fator";
import {
  UpdateItemProcessoFatorRequest,
  UpdateItemProcessoFatorResponse,
} from "../daos/update/update_item_processo_riscos_fator";
import {
  CreateItemProcessoFatorRequest,
  CreateItemProcessoFatorResponse,
} from "../daos/create/create_item_processo_fator";
import {
  DeleteItemProcessoFatorRequest,
  DeleteItemProcessoFatorResponse,
} from "../daos/delete/delete_item_processo_fator";
import {
  CreateItemProcessoIndicadorRequest,
  CreateItemProcessoIndicadorResponse,
} from "../daos/create/create_item_processo_indicador";
import {
  GetAllQualidadeItemProcessoIndicadorRequest,
  GetAllQualidadeItemProcessoIndicadorResponse,
} from "../daos/read/get_all_qualidade_item_processo_indicador";
import {
  DeleteItemProcessoIndicadorRequest,
  DeleteItemProcessoIndicadorResponse,
} from "../daos/delete/delete_item_processo_indicador";
import {
  GetArquivoRequest,
} from "../daos/read/get_arquivo";
import { GetAllIndicadoresResponse } from "../daos/read/get_all_indicadores";
import { QualidadeIndicadores } from "../../domain/models/qualidade_indicadores";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";
import { axiosInstance } from "../../../../common/utils/axios_instance";

export class QualidadeService implements IQualidadeService {
  //#region  Qualidade
  async getAllListagemAcoesMelhorias(
    request: GetAllQualidadeAcoesMelhoriasRequest,
  ): Promise<GetAllQualidadeAcoesMelhoriasResponse> {
    try {
      const result = await axiosInstance({}).post(
        `Qualidade/acaoQualidade/listAcaoQualidade`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllQualidadeAcoesMelhoriasResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createAcoesPreventivas(
    request: CreateAcoePreventivasRequest,
  ): Promise<CreateAcoePreventivasResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/qualidade/acaoQualidade/create`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<CreateAcoePreventivasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateAcoesPreventivas(
    request: UpdadeAcoesPreventivasRequest,
  ): Promise<UpdateAcoesPreventivasResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/qualidade/acaoQualidade/update`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<UpdateAcoesPreventivasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteAcoesPreventivas(
    request: DeleteAcoesPreventivasRequest,
  ): Promise<DeleteAcoesPreventivasResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/qualidade/acaoQualidade/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteAcoesPreventivasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getArquivo({
    IdAcaoQualidade,
    imagePosition,
  }: GetArquivoRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/qualidade/acaoQualidade/${IdAcaoQualidade}/image/${imagePosition}`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region Acao Preventiva Corretiva
  async createAcaoPreventivaCorretiva(
    request: CreateAcaoPreventivaCorretivaRequest,
  ): Promise<CreateAcaoPreventivaCorretivaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/acaoprevcorretiva/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateAcaoPreventivaCorretivaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllListagemAcaoPrevCorretivas(
    request: GetAllQualidadeAcaoPrevCorretivasRequest,
  ): Promise<GetAllQualidadeAcaoPrevCorretivasResponse> {
    try {
      const result = await axiosInstance({}).post(
        `qualidade/acaoprevcorretiva/listAcaoPrevCorretiva`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllQualidadeAcaoPrevCorretivasResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateAcaoPrevCorretivas(
    request: UpdadeAcaoPrevCorretivasRequest,
  ): Promise<UpdateAcaoPrevCorretivasResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/acaoprevcorretiva/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateAcaoPrevCorretivasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteAcaoPrevCorretivas(
    request: DeleteAcaoPrevCorretivasRequest,
  ): Promise<DeleteAcaoPrevCorretivasResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/qualidade/acaoprevcorretiva/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteAcaoPrevCorretivasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region  CronogramaSGQ
  async getAllListagemCronogramaSGQ(
    request: GetAllQualidadeCronogramaSGQRequest,
  ): Promise<GetAllQualidadeCronogramaSGQResponse> {
    try {
      const result = await axiosInstance({}).post(
        `qualidade/cronogrmasgq/CronogramaSGQ_lista`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllQualidadeCronogramaSGQResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteCronogramaSGQ(
    request: DeleteCronogramaSGQRequest,
  ): Promise<DeleteCronogramaSGQResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/qualidade/cronogrmasgq/delete`,
        { data: request },
      );
      const response = handleAxiosResponse<DeleteCronogramaSGQResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createCronogramaSGQ(
    request: CreateCronogramaSGQRequest,
  ): Promise<CreateCronogramaSGQResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/cronogrmasgq/create`,
        request,
      );
      const response = handleAxiosResponse<CreateCronogramaSGQResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateCronogramaSGQ(
    request: UpdateCronogramaSGQRequest,
  ): Promise<UpdateCronogramaSGQResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/cronogrmasgq/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateCronogramaSGQResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region  ProvisaoRecurso
  async getAllListagemProvisaoRecurso(
    request: GetAllQualidadeProvisaoRecursoRequest,
  ): Promise<GetAllQualidadeProvisaoRecursoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `Qualidade/provisaoRecurso/listProvisaoRecurso`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllQualidadeProvisaoRecursoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteProvisaoRecurso(
    request: DeleteProvisaoRecursoRequest,
  ): Promise<DeleteProvisaoRecursoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/qualidade/provisaoRecurso/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteProvisaoRecursoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createProvisaoRecurso(
    request: CreateProvisaoRecursoRequest,
  ): Promise<CreateProvisaoRecursoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/provisaoRecurso/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateProvisaoRecursoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateProvisaoRecurso(
    request: UpdateProvisaoRecursoRequest,
  ): Promise<UpdateProvisaoRecursoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/provisaoRecurso/update`,
        request,
      );
      const response =
        handleAxiosResponse<CreateProvisaoRecursoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Indicadores
  async getAllListagemIndicadores(
    request: GetAllQualidadeIndicadoresRequest,
  ): Promise<GetAllQualidadeIndicadoresResponse> {
    try {
      const result = await axiosInstance({}).post(
        `Qualidade/indicadores/listIndicadores`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllQualidadeIndicadoresResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteIndicadores(
    request: DeleteIndicadoresRequest,
  ): Promise<DeleteIndicadoresResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/qualidade/indicadores/delete`,
        { data: request },
      );
      const response = handleAxiosResponse<DeleteIndicadoresResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createIndicadores(
    request: CreateIndicadoresRequest,
  ): Promise<CreateIndicadoresResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/indicadores/create`,
        request,
      );
      const response = handleAxiosResponse<CreateIndicadoresResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateIndicadores(
    request: UpdateIndicadoresRequest,
  ): Promise<UpdateIndicadoresResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/indicadores/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateIndicadoresResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region ProcessosRiscos
  async getAllListagemProcessosRiscos(
    request: GetAllQualidadeProcessosRiscosRequest,
  ): Promise<GetAllQualidadeProcessosRiscosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `Qualidade/processorisco/listProcessoRisco`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllQualidadeProcessosRiscosResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteProcessoRiscos(
    request: DeleteProcessoRiscosRequest,
  ): Promise<DeleteProcessoRiscosResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/qualidade/processorisco/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteProcessoRiscosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createProcessoRiscos(
    request: CreateProcessoRiscosRequest,
  ): Promise<CreateProcessoRiscosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/processorisco/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateProcessoRiscosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async copyProcessoRiscos(
    request: CopyProcessoRiscosRequest,
  ): Promise<CopyProcessoRiscosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/processorisco/copy`,
        request,
      );
      const response = handleAxiosResponse<CopyProcessoRiscosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateProcessoRiscos(
    request: UpdateProcessoRiscosRequest,
  ): Promise<CreateProcessoRiscosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/processorisco/update`,
        request,
      );
      const response =
        handleAxiosResponse<CreateProcessoRiscosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region  ItemProcessoRiscos
  async getAllListagemItemProcessoRiscos(
    request: GetAllQualidadeItemProcessoRiscosRequest,
  ): Promise<GetAllQualidadeItemProcessoRiscosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `Qualidade/itemprocessorisco/listItemProcessoRisco`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllQualidadeItemProcessoRiscosResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteItemProcessoRiscos(
    request: DeleteItemProcessoRiscosRequest,
  ): Promise<DeleteItemProcessoRiscosResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/qualidade/itemprocessorisco/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteProcessoRiscosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createItemProcessoRiscos(
    request: CreateItemProcessoRiscosRequest,
  ): Promise<CreateItemProcessoRiscosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/itemprocessorisco/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateItemProcessoRiscosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateItemProcessoRiscos(
    request: UpdateItemProcessoRiscosRequest,
  ): Promise<UpdateItemProcessoRiscosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/itemprocessorisco/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateItemProcessoRiscosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region  Interesse
  async getAllListagemItemProcessoInteresse(
    request: GetAllQualidadeItemProcessoInteresseRequest,
  ): Promise<GetAllQualidadeItemProcessoInteresseResponse> {
    try {
      const result = await axiosInstance({}).post(
        `Qualidade/itemprocessointeresse/listProcessoInteresse`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllQualidadeItemProcessoInteresseResponse>(
          result,
        );
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createItemProcessoRiscosInteresse(
    request: CreateItemProcessoRiscosInteresseRequest,
  ): Promise<CreateItemProcessoRiscosInteresseResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/itemprocessointeresse/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateItemProcessoRiscosInteresseResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateItemProcessoRiscosInteresse(
    request: UpdateItemProcessoRiscosInteresseRequest,
  ): Promise<UpdateItemProcessoRiscosInteresseResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/itemprocessointeresse/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateItemProcessoRiscosInteresseResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteItemProcessoInteresse(
    request: DeleteItemProcessoInteresseRequest,
  ): Promise<DeleteItemProcessoInteresseResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/qualidade/itemprocessointeresse/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteItemProcessoInteresseResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Fator
  async getAllListagemItemProcessoFator(
    request: GetAllQualidadeItemProcessoFatorRequest,
  ): Promise<GetAllQualidadeItemProcessoFatorResponse> {
    try {
      const result = await axiosInstance({}).post(
        `Qualidade/itemprocessofator/listProcessoFator`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllQualidadeItemProcessoFatorResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createItemProcessoFator(
    request: CreateItemProcessoFatorRequest,
  ): Promise<CreateItemProcessoFatorResponse> {
    try {
      const result = await axiosInstance({}).post(
        `Qualidade/itemprocessofator/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateItemProcessoFatorResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateItemProcessoFator(
    request: UpdateItemProcessoFatorRequest,
  ): Promise<UpdateItemProcessoFatorResponse> {
    try {
      const result = await axiosInstance({}).post(
        `Qualidade/itemprocessofator/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateItemProcessoFatorResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteItemProcessoFator(
    request: DeleteItemProcessoFatorRequest,
  ): Promise<DeleteItemProcessoFatorResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `Qualidade/itemprocessofator/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteItemProcessoFatorResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region ItemProcessoIndicador
  async createProcesoIndicadores(
    request: CreateItemProcessoIndicadorRequest,
  ): Promise<CreateItemProcessoIndicadorResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/qualidade/processoindicador/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateItemProcessoIndicadorResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getAllListagemItemProcessoIndicador(
    request: GetAllQualidadeItemProcessoIndicadorRequest,
  ): Promise<GetAllQualidadeItemProcessoIndicadorResponse> {
    try {
      const result = await axiosInstance({}).post(
        `Qualidade/processoindicador/listProcessoIndicador`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllQualidadeItemProcessoIndicadorResponse>(
          result,
        );
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteItemProcessoIndicador(
    request: DeleteItemProcessoIndicadorRequest,
  ): Promise<DeleteItemProcessoIndicadorResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `Qualidade/processoindicador/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteItemProcessoIndicadorResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion
  //#region Principal
  async getAllIndicadores(): Promise<GetAllIndicadoresResponse> {
    try {
      const result = await axiosInstance({}).get(
        "/Qualidade/principal/indicadores",
      );
      const rawData = handleAxiosResponse<QualidadeIndicadores>(result);
      const response: GetAllIndicadoresResponse = {
        indicadores: rawData,
      };
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion
}
